<template>
  <div class="additional-resource-card">
    <p class="paragraph-two">
      {{ cardDetails.Title }}
    </p>

    <a :href="cardDetails.DestinationUrl" target="_blank" class="link">Learn more</a>
  </div>
</template>

<script>
export default {
  name: "AdditionalResourceCard",
  props: {
    cardDetails: Object,
  },
};
</script>

<style lang="scss" scoped>
.additional-resource-card {
  padding: 0 $spacer-four $spacer-six $spacer-five;
  text-align: left;

  @include tablet {
    display: inline-block;
    width: 33.333333%;
  }

  @include wide-mobile {
    width: 100%;
  }
}
</style>